var deprecate = require('util-deprecate');

module.exports = deprecate(require('sprintf-js').vsprintf,
  'vsprintf() will be removed in the next major release, use the sprintf-js package instead.');



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/vsprintf.js
// module id = 506
// module chunks = 0